<template>
  <d-select v-model="computedValue" :label="label" expanded :multiple="multiple" :placeholder="placeholder">
    <option value="" />
    <option :value="returnAbbrev ? 'AL' : 'Alabama'">
      {{ displayAbbrev ? 'AL' : 'Alabama' }}
    </option>
    <option :value="returnAbbrev ? 'AK' : 'Alaska'">
      {{ displayAbbrev ? 'AK' : 'Alaska' }}
    </option>
    <option :value="returnAbbrev ? 'AZ' : 'Arizona'">
      {{ displayAbbrev ? 'AZ' : 'Arizona' }}
    </option>
    <option :value="returnAbbrev ? 'AR' : 'Arkansas'">
      {{ displayAbbrev ? 'AR' : 'Arkansas' }}
    </option>
    <option :value="returnAbbrev ? 'CA' : 'California'">
      {{ displayAbbrev ? 'CA' : 'California' }}
    </option>
    <option :value="returnAbbrev ? 'CO' : 'Colorado'">
      {{ displayAbbrev ? 'CO' : 'Colorado' }}
    </option>
    <option :value="returnAbbrev ? 'CT' : 'Connecticut'">
      {{ displayAbbrev ? 'CT' : 'Connecticut' }}
    </option>
    <option :value="returnAbbrev ? 'DE' : 'Delaware'">
      {{ displayAbbrev ? 'DE' : 'Delaware' }}
    </option>
    <option :value="returnAbbrev ? 'DC' : 'District Of Columbia'">
      {{ displayAbbrev ? 'DC' : 'District Of Columbia' }}
    </option>
    <option :value="returnAbbrev ? 'FL' : 'Florida'">
      {{ displayAbbrev ? 'FL' : 'Florida' }}
    </option>
    <option :value="returnAbbrev ? 'GA' : 'Georgia'">
      {{ displayAbbrev ? 'GA' : 'Georgia' }}
    </option>
    <option :value="returnAbbrev ? 'HI' : 'Hawaii'">
      {{ displayAbbrev ? 'HI' : 'Hawaii' }}
    </option>
    <option :value="returnAbbrev ? 'ID' : 'Idaho'">
      {{ displayAbbrev ? 'ID' : 'Idaho' }}
    </option>
    <option :value="returnAbbrev ? 'IL' : 'Illinois'">
      {{ displayAbbrev ? 'IL' : 'Illinois' }}
    </option>
    <option :value="returnAbbrev ? 'IN' : 'Indiana'">
      {{ displayAbbrev ? 'IN' : 'Indiana' }}
    </option>
    <option :value="returnAbbrev ? 'IA' : 'Iowa'">
      {{ displayAbbrev ? 'IA' : 'Iowa' }}
    </option>
    <option :value="returnAbbrev ? 'KS' : 'Kansas'">
      {{ displayAbbrev ? 'KS' : 'Kansas' }}
    </option>
    <option :value="returnAbbrev ? 'KY' : 'Kentucky'">
      {{ displayAbbrev ? 'KY' : 'Kentucky' }}
    </option>
    <option :value="returnAbbrev ? 'LA' : 'Louisiana'">
      {{ displayAbbrev ? 'LA' : 'Louisiana' }}
    </option>
    <option :value="returnAbbrev ? 'ME' : 'Maine'">
      {{ displayAbbrev ? 'ME' : 'Maine' }}
    </option>
    <option :value="returnAbbrev ? 'MD' : 'Maryland'">
      {{ displayAbbrev ? 'MD' : 'Maryland' }}
    </option>
    <option :value="returnAbbrev ? 'MA' : 'Massachusetts'">
      {{ displayAbbrev ? 'MA' : 'Massachusetts' }}
    </option>
    <option :value="returnAbbrev ? 'MI' : 'Michigan'">
      {{ displayAbbrev ? 'MI' : 'Michigan' }}
    </option>
    <option :value="returnAbbrev ? 'MN' : 'Minnesota'">
      {{ displayAbbrev ? 'MN' : 'Minnesota' }}
    </option>
    <option :value="returnAbbrev ? 'MS' : 'Mississippi'">
      {{ displayAbbrev ? 'MS' : 'Mississippi' }}
    </option>
    <option :value="returnAbbrev ? 'MO' : 'Missouri'">
      {{ displayAbbrev ? 'MO' : 'Missouri' }}
    </option>
    <option :value="returnAbbrev ? 'MT' : 'Montana'">
      {{ displayAbbrev ? 'MT' : 'Montana' }}
    </option>
    <option :value="returnAbbrev ? 'NE' : 'Nebraska'">
      {{ displayAbbrev ? 'NE' : 'Nebraska' }}
    </option>
    <option :value="returnAbbrev ? 'NV' : 'Nevada'">
      {{ displayAbbrev ? 'NV' : 'Nevada' }}
    </option>
    <option :value="returnAbbrev ? 'NH' : 'New Hampshire'">
      {{ displayAbbrev ? 'NH' : 'New Hampshire' }}
    </option>
    <option :value="returnAbbrev ? 'NJ' : 'New Jersey'">
      {{ displayAbbrev ? 'NJ' : 'New Jersey' }}
    </option>
    <option :value="returnAbbrev ? 'NM' : 'New Mexico'">
      {{ displayAbbrev ? 'NM' : 'New Mexico' }}
    </option>
    <option :value="returnAbbrev ? 'NY' : 'New York'">
      {{ displayAbbrev ? 'NY' : 'New York' }}
    </option>
    <option :value="returnAbbrev ? 'NC' : 'North Carolina'">
      {{ displayAbbrev ? 'NC' : 'North Carolina' }}
    </option>
    <option :value="returnAbbrev ? 'ND' : 'North Dakota'">
      {{ displayAbbrev ? 'ND' : 'North Dakota' }}
    </option>
    <option :value="returnAbbrev ? 'OH' : 'Ohio'">
      {{ displayAbbrev ? 'OH' : 'Ohio' }}
    </option>
    <option :value="returnAbbrev ? 'OK' : 'Oklahoma'">
      {{ displayAbbrev ? 'OK' : 'Oklahoma' }}
    </option>
    <option :value="returnAbbrev ? 'OR' : 'Oregon'">
      {{ displayAbbrev ? 'OR' : 'Oregon' }}
    </option>
    <option :value="returnAbbrev ? 'PA' : 'Pennsylvania'">
      {{ displayAbbrev ? 'PA' : 'Pennsylvania' }}
    </option>
    <option :value="returnAbbrev ? 'PR' : 'Puerto Rico'">
      {{ displayAbbrev ? 'PR' : 'Puerto Rico' }}
    </option>
    <option :value="returnAbbrev ? 'RI' : 'Rhode Island'">
      {{ displayAbbrev ? 'RI' : 'Rhode Island' }}
    </option>
    <option :value="returnAbbrev ? 'SC' : 'South Carolina'">
      {{ displayAbbrev ? 'SC' : 'South Carolina' }}
    </option>
    <option :value="returnAbbrev ? 'SD' : 'South Dakota'">
      {{ displayAbbrev ? 'SD' : 'South Dakota' }}
    </option>
    <option :value="returnAbbrev ? 'TN' : 'Tennessee'">
      {{ displayAbbrev ? 'TN' : 'Tennessee' }}
    </option>
    <option :value="returnAbbrev ? 'TX' : 'Texas'">
      {{ displayAbbrev ? 'TX' : 'Texas' }}
    </option>
    <option :value="returnAbbrev ? 'UT' : 'Utah'">
      {{ displayAbbrev ? 'UT' : 'Utah' }}
    </option>
    <option :value="returnAbbrev ? 'VT' : 'Vermont'">
      {{ displayAbbrev ? 'VT' : 'Vermont' }}
    </option>
    <option :value="returnAbbrev ? 'VA' : 'Virginia'">
      {{ displayAbbrev ? 'VA' : 'Virginia' }}
    </option>
    <option :value="returnAbbrev ? 'WA' : 'Washington'">
      {{ displayAbbrev ? 'WA' : 'Washington' }}
    </option>
    <option :value="returnAbbrev ? 'WV' : 'West Virginia'">
      {{ displayAbbrev ? 'WV' : 'West Virginia' }}
    </option>
    <option :value="returnAbbrev ? 'WI' : 'Wisconsin'">
      {{ displayAbbrev ? 'WI' : 'Wisconsin' }}
    </option>
    <option :value="returnAbbrev ? 'WY' : 'Wyoming'">
      {{ displayAbbrev ? 'WY' : 'Wyoming' }}
    </option>
  </d-select>
</template>

<script>
  import DSelect from '../../elements/DSelect/DSelect.vue';

  /**
   * @displayName StateSelector
   */

  export default {
    name: 'DStateSelector',
    components: { DSelect },
    props: {
      label: String,
      placeholder: String,
      value: {
        type: [String, Number, Boolean, Object, Array, Symbol, Function],
        default: null,
      },

      multiple: {
        type: Boolean,
        default: false,
      },

      returnAbbrev: {
        type: Boolean,
        default: false,
      },

      displayAbbrev: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        newValue: this.value,
      };
    },

    computed: {
      computedValue: {
        get() {
          return this.newValue;
        },

        set(value) {
          this.newValue = value;
          this.$emit('input', value);
        },
      },
    },
  };
</script>